// src/views/BusinessLeads.js
import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {collection,onSnapshot,query,orderBy} from 'firebase/firestore';
import {useAuth} from '../../auth/AuthContext';

const BusinessLeads=()=>{
  const {user}=useAuth();
  const businessId=user?.businessId||'axuremoval'; // fallback for now

  const [leads,setLeads]=useState([]);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    if(!businessId)return;

    const q=query(
      collection(db,'businesses',businessId,'leads'),
      orderBy('createdAt','desc')
    );

    const unsub=onSnapshot(q,(snap)=>{
      const arr=[];
      snap.forEach((d)=>arr.push({...d.data(),id:d.id}));
      setLeads(arr);
      setLoading(false);
    });

    return()=>unsub();
  },[businessId]);

  if(loading){
    return(
      <div className="flex justify-center items-center min-h-screen bg-neutral-950 text-white">
        <p className="opacity-60 text-lg">Loading leads...</p>
      </div>
    );
  }

  return(
    <div className="min-h-screen bg-neutral-950 text-white px-6 py-10">
      <div className="max-w-6xl mx-auto">

        {/* Title */}
        <h2 className="text-3xl font-semibold mb-8">Business Leads</h2>

        {/* Table */}
        <div className="bg-neutral-900 rounded-2xl shadow-lg p-6">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-neutral-400 text-sm uppercase tracking-wide border-b border-neutral-800">
                <th className="py-3">Name</th>
                <th className="py-3">Contact</th>
                <th className="py-3">Job Type</th>
                <th className="py-3">Status</th>
                <th className="py-3">Date</th>
              </tr>
            </thead>

            <tbody>
              {leads.length===0&&(
                <tr>
                  <td colSpan="5" className="text-center py-6 opacity-60">
                    No leads found.
                  </td>
                </tr>
              )}

              {leads.map((l)=>(
                <tr 
                  key={l.id}
                  className="border-b border-neutral-800 hover:bg-neutral-800/40 transition"
                >
                  <td className="py-3">{l.name||'-'}</td>
                  <td className="py-3">{l.phone||l.email||'-'}</td>
                  <td className="py-3">{l.jobType||l.category||'-'}</td>
                  <td className="py-3">
                    <span className={`px-3 py-1 rounded-lg text-sm ${
                      l.status==='converted'
                        ? 'bg-green-600/20 text-green-400'
                        : l.status==='pending'
                        ? 'bg-yellow-600/20 text-yellow-400'
                        : 'bg-neutral-700 text-neutral-300'
                    }`}>
                      {l.status||'unknown'}
                    </span>
                  </td>
                  <td className="py-3">
                    {l.createdAt
                      ? new Date(l.createdAt).toLocaleDateString()
                      : '-'
                    }
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default BusinessLeads;
